import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cart-promo__block" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = { class: "form-field form-field--text form-field--1 form-field--m form-field--primary" };
import { ref } from 'vue';
import CartEventBus from "../../CartEventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CouponInput',
    setup(__props) {
        const coupon = ref('');
        const input = ref();
        function onkeypress(e) {
            e.preventDefault();
            input.value.blur();
            enterCoupon();
        }
        function enterCoupon() {
            if (coupon.value.trim() !== '') {
                CartEventBus.emit('coupons:add', coupon.value);
                coupon.value = '';
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "coupon_code",
                                class: "form-control",
                                placeholder: "Промокод на скидку",
                                ref_key: "input",
                                ref: input,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((coupon).value = $event)),
                                onChange: enterCoupon,
                                onKeypress: _withKeys(onkeypress, ["enter"])
                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                [_vModelText, coupon.value]
                            ])
                        ])
                    ])
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", { class: "cart-promo__block" }, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn--2 btn--m btn--black wide",
                        id: "coupon_button",
                        onClick: enterCoupon
                    }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("span", { class: "btn__label" }, "Применить", -1 /* CACHED */)
                        ]))])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
